(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-roster"] && !Shopify.designMode) return;
  try {
    
function initCreatorRows(root) {
  root.querySelectorAll('[data-cr-row]').forEach(row => {
    if (row.dataset.crReady) return;
    row.dataset.crReady = 'true';
    const cards = Array.from(row.children);
    const controls = row.nextElementSibling;
    if (!cards.length || !controls?.matches('[data-cr-controls]')) return;
    const toggle = controls.querySelector('[data-cr-toggle]');
    const previous = controls.querySelector('[data-cr-prev]');
    const next = controls.querySelector('[data-cr-next]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const copies = cards.map(card => {
      const copy = card.cloneNode(true);
      copy.dataset.crCopy = '';
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('data-shopify-editor-block');
      copy.removeAttribute('id');
      copy.setAttribute('tabindex', '-1');
      copy.querySelectorAll('a,button,input,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
      row.appendChild(copy);
      return copy;
    });
    let visible = false, hovered = false, focused = false, paused = false;
    let frame = 0, last = 0, position = 0, seam = 0, fits = false;
    function label() {
      toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Resume automatic creator rotation' : 'Pause automatic creator rotation');
      toggle.disabled = motion.matches || fits;
      previous.disabled = next.disabled = fits;
    }
    function sync() {
      cancelAnimationFrame(frame);
      frame = 0; last = 0; position = row.scrollLeft;
      const running = visible && !document.hidden && !motion.matches && !paused && !hovered && !focused && !fits;
      row.dataset.crPlaying = String(running);
      label();
      if (running) frame = requestAnimationFrame(tick);
    }
    function tick(time) {
      if (last && seam > 0) {
        position = (position + Math.min(time - last, 64) * .025) % seam;
        row.scrollLeft = position;
      }
      last = time;
      frame = requestAnimationFrame(tick);
    }
    function measure() {
      row.classList.remove('is-static');
      copies.forEach(copy => copy.style.display = '');
      seam = cards.reduce((sum, card) => sum + card.getBoundingClientRect().width + 20, 0);
      fits = seam - 20 <= row.clientWidth;
      row.classList.toggle('is-static', motion.matches || fits);
      if (seam) row.scrollLeft %= seam;
      sync();
    }
    function stopForInteraction() { paused = true; sync(); }
    toggle.addEventListener('click', () => { paused = !paused; sync(); });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    function move(direction) {
      stopForInteraction();
      const step = cards[0].getBoundingClientRect().width + 20;
      const max = row.scrollWidth - row.clientWidth;
      let target = row.scrollLeft + direction * step;
      if (target < 0) target = motion.matches ? max : Math.max(0, seam - step);
      if (target > max) target = 0;
      row.scrollTo({left:target,behavior:motion.matches ? 'auto' : 'smooth'});
    }
    row.addEventListener('pointerenter', event => { if(event.pointerType === 'mouse') { hovered = true; sync(); } });
    row.addEventListener('pointerleave', () => { hovered = false; sync(); });
    row.addEventListener('pointerdown', stopForInteraction, {passive:true});
    row.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) stopForInteraction(); }, {passive:true});
    row.addEventListener('focusin', () => { focused = true; sync(); });
    row.addEventListener('focusout', () => { focused = false; sync(); });
    row.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', measure);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
    observer.observe(row);
    const resize = new ResizeObserver(measure);
    resize.observe(row);
    controls.hidden = false;
    measure();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(row)) return;
      cancelAnimationFrame(frame); observer.disconnect(); resize.disconnect();
      document.removeEventListener('visibilitychange', sync);
      motion.removeEventListener('change', measure);
    });
  });
}
initCreatorRows(document);
document.addEventListener('shopify:section:load', event => initCreatorRows(event.target));

  } catch(e) { console.error(e); }
})();
})();
